import { useState } from "react";
import toast from "react-hot-toast";

import { usePatientDeaspCertificates } from "features/healthlink/hooks/usePatientDeaspCertificates";

import { formatCertificateContent } from "../utils/formatContent";

export const useInsertCertificate = ({ patientId, onInsert }) => {
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");

  const { data, isLoading } = usePatientDeaspCertificates({
    patientId,
    page: 1,
    rows: 100,
  });

  const certificates = data?.data ?? [];

  const filtered = certificates.filter((certificate) => {
    const term = search.toLowerCase();
    const cert = certificate.deaspCertificate;

    return (
      (cert?.natureOfCondition || "").toLowerCase().includes(term) ||
      (cert?.natureOfConditionCode || "").toLowerCase().includes(term) ||
      (cert?.certFormType || "").toLowerCase().includes(term)
    );
  });

  const handleInsert = (certificate) => {
    onInsert(formatCertificateContent(certificate));
    setShowModal(false);
    setSearch("");
    toast.success("Certificate added to email");
  };

  return {
    showModal,
    openModal: () => setShowModal(true),
    closeModal: () => {
      setShowModal(false);
      setSearch("");
    },
    search,
    setSearch,
    filtered,
    isLoading,
    handleInsert,
  };
};
